import React, { useState, useEffect, useRef } from "react";
import { Modal } from "antd";
import NavigationBar from "../../components/navigation-bar/index";
import wasapayLogo from "../../assets/img/local-apm-horizontal.svg";
import padlock from "../../assets/img/padlock.svg";
import cancel from "../../assets/img/cancel.svg";
import Card from "../../components/card/index";
import BankImg from "../../assets/img/card.svg";
import Transfer from "../../components/transfer/index";
import { usePayDataContext } from "../../contexts/PayDataContext";
import { PrimaryButton } from "../../components/button";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useViewContext } from "../../contexts/view.context";
import { formatCurrencyAmount } from "../../utils/helpers";
import "./checkout.scss";

const url = process.env.REACT_APP_API_URL;

const paymentMap = {
  card: Card,
  transfer: Transfer,
} as Record<string, any>;

const App: React.FC = () => {
  const { view, setView } = useViewContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMenu, setShowMenu] = React.useState(false);
  const [menu, setMenu] = useState("card");
  const { isLoading, merchantData, getRef } = usePayDataContext();

  const navigate = useNavigate();

  useEffect(() => {
    getRef();
  }, []);

  const PaymentMethod = paymentMap[menu];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  //   navigate("/");
  // };

  const changeMenu = (tab: any) => {
    setMenu(tab);
    setView(tab);
  };

  const changeMenuMobile = (tab: any) => {
    setMenu(tab);
    setShowMenu(true);
    setView(tab);
  };

  const handleCancel = () => {
    const myEvent = new CustomEvent("modalClosed2", { detail: "Modal was closed2" });
    window.dispatchEvent(myEvent);
    window.parent.postMessage({ action: "modalClosed3", data: "Modal was closed3" }, "*");
    setIsModalOpen(false);
  };
  
  useEffect(() => {
    showModal();
  }, []);

  const ActivePayment = () => {
    return (
      <>
        <div className="activeMethod hidden p-5 capitalize">
          <div className="flex">
            <img src={BankImg} alt="BankImage" className="w-4 h-4 mr-3" />
            <p className="text-xs font-light">{menu}</p>
          </div>
        </div>
        <div className="payDiv flex flex-col px-7 pb-7 space-y-4 w-full pt-[0.1em]">
          <div className="paymentMethod">
            <div className="flex items-center justify-between paymentMethodHeader">
              <div className="w-32 h-24 flex items-center justify-center overflow-hidden">
                <img
                  src={wasapayLogo}
                  alt="Local APM"
                  className="object-contain w-full h-2/4"
                />
              </div>
              {isLoading ? (
                <div className="w-1/5 text-right">
                  <div role="status" className="max-w-sm animate-pulse">
                    <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-20 mb-4"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
                  </div>
                </div>
              ) : (
                <div className="text-right">
                  <h6 className="Inter-Semibold">
                    <sup>NGN </sup>
                    <span className="mt-10 font-bold">
                      {formatCurrencyAmount(merchantData?.amount)}
                    </span>
                  </h6>
                  <p className="Inter-Regular text-xs">Payment for: {merchantData?.title}</p>
                </div>
              )}
            </div>
            <div className="borderLine"></div>
            <PaymentMethod />
          </div>
        </div>

        {view !== "success" ? (
          <div className="mobilePayBottom hidden pt-5 w-full bg-white">
            <div
              className="w-full flex justify-center mb-5"
              onClick={() => setShowMenu(false)}
            >
              <PrimaryButton
                text="Change Payment Method"
                className="payBorder rounded flex justify-center font-light"
                id="payment-method"
              />
            </div>
            <div
              className="w-full flex justify-center mb-5 "
              onClick={() => setShowMenu(false)}
            >
              <div className="cancelBorder rounded flex justify-center">
                <img src={cancel} alt="cancel" className="mr-2" />
                <button className="font-light">Cancel Payment</button>
              </div>
            </div>

            <div className="flex justify-center w-full pt-10 pb-10 secured">
              <img src={padlock} alt="padlock" className="w-3 h-3 mr-3 mt-1" />
              <p>
                Secured by <span>Local APM</span>
              </p>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <div className="w-full">
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <div className="mainNav">
          <div className="flex w-full">
            <NavigationBar setMenu={changeMenu} menu={menu} />
            <ActivePayment />
          </div>
        </div>
        <div className="mobileNav hidden">
          {showMenu ? (
            <ActivePayment />
          ) : (
            <NavigationBar setMenu={changeMenuMobile} menu={menu} />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default App;
